import technofest_0 from "../../images/projects/technofest/0.PNG";
import technofest_1 from "../../images/projects/technofest/1.PNG";
import technofest_2 from "../../images/projects/technofest/2.PNG";
import technofest_3 from "../../images/projects/technofest/3.PNG";
import technofest_4 from "../../images/projects/technofest/4.PNG";
import technofest_5 from "../../images/projects/technofest/5.PNG";
import technofest_6 from "../../images/projects/technofest/6.PNG";
import technofest_7 from "../../images/projects/technofest/7.PNG";
import technofest_8 from "../../images/projects/technofest/8.PNG";
import technofest_9 from "../../images/projects/technofest/9.PNG";
import technofest_10 from "../../images/projects/technofest/10.PNG";
import technofest_11 from "../../images/projects/technofest/11.PNG";
import technofest_12 from "../../images/projects/technofest/12.PNG";
import technofest_13 from "../../images/projects/technofest/13.PNG";

export default function technofestImages() {
  return [
    technofest_0,
    technofest_1,
    technofest_2,
    technofest_3,
    technofest_4,
    technofest_5,
    technofest_6,
    technofest_7,
    technofest_8,
    technofest_9,
    technofest_10,
    technofest_11,
    technofest_12,
    technofest_13,
  ];
}